/**
 * 兼容性工具库
 */


/**
 * 获取兼容的WeakRef
 * @returns {WeakRef|Function} WeakRef构造函数或兼容实现
 */
function getWeakRef() {
  // 检查浏览器是否原生支持WeakRef
  if (window.WeakRef) {
    return window.WeakRef;
  }

  // 否则返回一个简单的替代实现
  return class WeakRefPolyfill {
    constructor(target) {
      // 存储目标对象的引用
      this.target = target;
    }

    // 返回存储的引用
    deref() {
      return this.target;
    }
  };
}

/**
 * 获取兼容的FinalizationRegistry
 * @returns {FinalizationRegistry|Function} FinalizationRegistry构造函数或兼容实现
 */
function getFinalizationRegistry() {
  // 检查浏览器是否原生支持FinalizationRegistry
  if (window.FinalizationRegistry) {
    return window.FinalizationRegistry;
  }

  // 否则返回一个简单的替代实现
  return class FinalizationRegistryPolyfill {
    constructor(callback) {
      this.callback = callback;
      this.registry = new Map();

      // 模拟垃圾回收检查
      this.checkGcInterval = setInterval(() => {
        this.registry.forEach((value, key) => {
          // 如果引用已经不存在，则调用回调
          if (!key.target) {
            this.callback(value);
            this.registry.delete(key);
          }
        });
      }, 1000);
    }

    register(target, holdings, unregisterToken) {
      const WeakRefPolyfill = getWeakRef();
      const ref = new WeakRefPolyfill(target);
      this.registry.set(ref, holdings);

      // 如果提供了注销令牌，则存储关联
      if (unregisterToken) {
        if (!this.unregisterMap) {
          this.unregisterMap = new Map();
        }
        if (!this.unregisterMap.has(unregisterToken)) {
          this.unregisterMap.set(unregisterToken, []);
        }
        this.unregisterMap.get(unregisterToken).push(ref);
      }
    }

    unregister(unregisterToken) {
      if (this.unregisterMap && this.unregisterMap.has(unregisterToken)) {
        const refs = this.unregisterMap.get(unregisterToken);
        refs.forEach(ref => this.registry.delete(ref));
        this.unregisterMap.delete(unregisterToken);
      }
    }

    // 清理定时器
    cleanup() {
      clearInterval(this.checkGcInterval);
    }
  };
}



// 导出工具函数
export {
  getWeakRef,
  getFinalizationRegistry,
};
